import { useGetInstallationHeaderMetricsQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  completedFinish: number;
  overdueFinish: number;
  upcomingFinish: number;
  remainingSelections: number;
}

export function useQuery(id: string) {
  const tuple = useGetInstallationHeaderMetricsQuery({
    variables: {
      projectId: id
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        completedFinish: tuple.data?.project?.installationsWithAllDecisionsComplete?.length ?? 0,
        overdueFinish: tuple.data?.project?.installationsWithOverDueDecisions?.length ?? 0,
        upcomingFinish: tuple.data?.project?.installationsWithUpcomingDecisions?.length ?? 0,
        remainingSelections: tuple.data?.project?.installationsWithDecisionsRemaining?.length ?? 0
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
    // []
  );
}
